export default "__VITE_ASSET__frV$YZAQ__"